import { render } from "./swipe.vue?vue&type=template&id=6ae28626&scoped=true"
import script from "./swipe.vue?vue&type=script&lang=js"
export * from "./swipe.vue?vue&type=script&lang=js"

import "./swipe.vue?vue&type=style&index=0&id=6ae28626&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae28626"]])

export default __exports__